exports.dashboard = [
    {
        title: 'Trang chủ',
        path: '/',
        name: 'layout',
        show: true,
        subMenu: null,
        breadcrumb: [
            {
                title: 'Trang chủ',
                path: '/',
                name: 'layout'
            },
        ],
    },
    {
        title: 'Danh sách hiện vật',
        path: 'artifact',
        name: 'artifact',
        show: true,
        subMenu: null,
        breadcrumb: [
            {
                title: 'Trang chủ',
                path: '/',
                name: 'layout'
            },
            {
                title: 'Danh sách hiện vật',
                path: null,
                name: null
            }
        ],
    },
    {
        title: 'Thêm hiện vật',
        path: 'artifact/add',
        name: 'artifact-add',
        show: true,
        subMenu: null,
        breadcrumb: [
            {
                title: 'Trang chủ',
                path: '/',
                name: 'layout'
            },
            {
                title: 'Thêm hiện vật',
                path: null,
                name: null
            }
        ],
    },
    // {
    //     title: 'Nghệ sĩ',
    //     path: null,
    //     name: null,
    //     show: true,
    //     subMenu: [
    //         {
    //             title: 'Danh sách nghệ sĩ',
    //             path: 'artist',
    //             name: 'artist',
    //             show: true,
    //             breadcrumb: [
    //                 {
    //                     title: 'Trang chủ',
    //                     path: '/',
    //                     name: 'layout'
    //                 },
    //                 {
    //                     title: 'Danh sách nghệ sĩ',
    //                     name: null,
    //                     path: null,
    //                 }
    //             ],
    //         },
    //         {
    //             title: 'Thêm mới nghệ sĩ',
    //             path: 'artist/add',
    //             name: 'artist-add',
    //             show: true,
    //             breadcrumb: [
    //                 {
    //                     title: 'Trang chủ',
    //                     path: '/',
    //                     name: 'layout'
    //                 },
    //                 {
    //                     title: 'Thêm mới nghệ sĩ',
    //                     name: null,
    //                     path: null,
    //                 }
    //             ],
    //         },
    //     ],
    // },
    // {
    //     title: 'Thể loại tác giả',
    //     path: 'category',
    //     name: 'category',
    //     show: true,
    //     subMenu: null,
    //     breadcrumb: [
    //         {
    //             title: 'Trang chủ',
    //             path: '/',
    //             name: 'layout'
    //         },
    //         {
    //             title: 'Thể loại tác giả',
    //             path: null,
    //             name: null
    //         }
    //     ],
    // },
    // {
    //     title: 'Triển lãm',
    //     path: null,
    //     name: null,
    //     show: true,
    //     subMenu: [
    //         {
    //             title: 'Danh sách triển lãm',
    //             path: 'exhibition',
    //             name: 'exhibition',
    //             show: true,
    //             breadcrumb: [
    //                 {
    //                     title: 'Trang chủ',
    //                     path: '/',
    //                     name: 'layout'
    //                 },
    //                 {
    //                     title: 'Danh sách triển lãm',
    //                     name: null,
    //                     path: null,
    //                 }
    //             ],
    //         },
    //         {
    //             title: 'Thêm triển lãm',
    //             path: 'exhibition/add',
    //             name: 'exhibition-add',
    //             show: true,
    //             breadcrumb: [
    //                 {
    //                     title: 'Trang chủ',
    //                     path: '/',
    //                     name: 'layout'
    //                 },
    //                 {
    //                     title: 'Thêm triển lãm',
    //                     name: null,
    //                     path: null,
    //                 }
    //             ],
    //         },
    //     ],
    // },
    // {
    //     title: 'Tác phẩm',
    //     path: null,
    //     name: null,
    //     show: true,
    //     subMenu: [
    //         {
    //             title: 'Danh sách tác phẩm',
    //             path: 'artwork',
    //             name: 'artwork',
    //             show: true,
    //             breadcrumb: [
    //                 {
    //                     title: 'Trang chủ',
    //                     path: '/',
    //                     name: 'layout'
    //                 },
    //                 {
    //                     title: 'Danh sách tác phẩm',
    //                     name: null,
    //                     path: null,
    //                 }
    //             ],
    //         },
    //         {
    //             title: 'Thêm tác phẩm',
    //             path: 'artwork/add',
    //             name: 'artwork-add',
    //             show: true,
    //             breadcrumb: [
    //                 {
    //                     title: 'Trang chủ',
    //                     path: '/',
    //                     name: 'layout'
    //                 },
    //                 {
    //                     title: 'Thêm tác phẩm',
    //                     name: null,
    //                     path: null,
    //                 }
    //             ],
    //         },
    //     ],
    // },
    // {
    //     title: 'Cài đặt chung',
    //     path: 'setting',
    //     name: 'setting',
    //     show: true,
    //     subMenu: null,
    //     breadcrumb: [
    //         {
    //             title: 'Trang chủ',
    //             path: '/',
    //             name: 'layout'
    //         },
    //         {
    //             title: 'Cài đặt chung',
    //             path: null,
    //             name: null
    //         }
    //     ],
    // },
];
